import { httpRequest } from "../../../utils/HttpRequest";
import { IBasicDetail, } from "./basicTypes";
class BasicService {
    async page(searchVo: IBasicDetail) {
        const apiUrl = "/vrm2/sale/findPage";
        return await httpRequest.post<IBasicDetail>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/web/base/search_one/${id}`;
        return await httpRequest.get<IBasicDetail>(apiUrl);
    }
    async insert(insertVo: IBasicDetail) {
        const apiUrl = `/web/base/insert`;
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: IBasicDetail) {
        const apiUrl = `/web/base/update`;
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async delete(id: string) {
        const apiUrl = `/web/base/delete/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
}
export const basicService = new BasicService();
